<template>
  <section class="diagnosis-upgrade-card brand-gate-card mb-4">
    <v-icon class="diagnosis-upgrade-card__icon" size="28" aria-hidden="true">mdi-lock-outline</v-icon>
    <div class="diagnosis-upgrade-card__copy">
      <div class="diagnosis-upgrade-card__title brand-gate-card__title">Unlock your AI visibility diagnosis</div>
      <p class="diagnosis-upgrade-card__body brand-gate-card__body">
        See why AI search leaves out your hospital and your doctors, with a clear list of fixes.
        Available on the Visibility, Intelligence and Enterprise plans.
      </p>
    </div>
    <v-btn
      variant="flat"
      class="brand-upgrade-cta-btn text-none"
      rounded="pill"
      size="large"
      @click="$router.push('/profile?tab=billing')"
    >
      Upgrade to run diagnosis →
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'DiagnosisUpgradeCard'
}
</script>

<style scoped>
.diagnosis-upgrade-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px 20px;
  padding: 20px 24px;
}

.diagnosis-upgrade-card__icon {
  flex-shrink: 0;
  color: var(--brand-amber-400) !important;
}

.diagnosis-upgrade-card__copy {
  flex: 1 1 280px;
  min-width: 0;
}

.diagnosis-upgrade-card__title {
  font-size: 1.0625rem;
  line-height: 1.4;
}

.diagnosis-upgrade-card__body {
  margin: 6px 0 0;
  font-size: 0.875rem;
  line-height: 1.5;
}
</style>
